import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "star-rating" }
const _hoisted_2 = {
  key: 1,
  class: "stars"
}
const _hoisted_3 = { class: "star__inner" }
const _hoisted_4 = {
  key: 2,
  class: "stars"
}
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "star__inner" }

import { EventNamesEnum } from "@/const/events";
import { IonIcon, IonText } from "@ionic/vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'StarRating',
  props: {
    modelValue: {},
    readonly: { type: Boolean },
    single: { type: Boolean, default: false },
    big: { type: Boolean, default: false }
  },
  setup(__props: any, { emit: __emit }) {



const emit = __emit;

function onStarClick(i: number) {
  emit(EventNamesEnum.OnUpdateModelValue, i);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.readonly)
      ? (_openBlock(), _createBlock(_unref(IonText), {
          key: 0,
          class: "star-rating__title"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.modelValue?.toFixed(1)), 1)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.single)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", {
            class: _normalizeClass(["star", { 'star__big': _ctx.big, 'star--semi': +_ctx.modelValue.toString().split('.')[1] > 0 }])
          }, [
            _createVNode(_unref(IonIcon), {
              class: "star__icon star__icon--default",
              src: "/assets/icon/star-circuit.svg"
            }),
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_unref(IonIcon), {
                class: "star__icon star__icon--active",
                src: "assets/icon/star.svg"
              })
            ])
          ], 2)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (i) => {
            return _createElementVNode("div", {
              class: _normalizeClass(["star", { 'star__big': _ctx.big, 'star--semi': i < _ctx.modelValue + 1 && i > _ctx.modelValue }]),
              key: i,
              onClick: ($event: any) => (!_ctx.readonly && onStarClick(i))
            }, [
              _createVNode(_unref(IonIcon), {
                class: "star__icon star__icon--default",
                src: "/assets/icon/star-circuit.svg"
              }),
              _createElementVNode("div", _hoisted_6, [
                (i < _ctx.modelValue + 1)
                  ? (_openBlock(), _createBlock(_unref(IonIcon), {
                      key: 0,
                      class: "star__icon star__icon--active",
                      src: "assets/icon/star.svg"
                    }))
                  : _createCommentVNode("", true)
              ])
            ], 10, _hoisted_5)
          }), 64))
        ]))
  ]))
}
}

})